import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.is.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React from 'react';

// 出错后显示的元素类型

// 判断依赖
var changeArray = function changeArray(a, b) {
  var _a, _b, _a2;
  if (a === void 0) {
    a = [];
  }
  if (b === void 0) {
    b = [];
  }
  return ((_a = a) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = b) === null || _b === void 0 ? void 0 : _b.length) || ((_a2 = a) === null || _a2 === void 0 ? void 0 : _a2.some(function (it, index) {
    return !Object.is(it, b[index]);
  }));
};

// 初始状态
var initialState = {
  error: null
};
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary() {
    var _this;
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _defineProperty(_assertThisInitialized(_this), "state", initialState);
    _defineProperty(_assertThisInitialized(_this), "updatedWithError", false);
    _defineProperty(_assertThisInitialized(_this), "resetErrorBoundary", function () {
      var _this$props$onReset, _this$props;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_this$props$onReset = (_this$props = _this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call.apply(_this$props$onReset, [_this$props].concat(args));
      _this.reset();
    });
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, errorInfo.componentStack);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var error = this.state.error;
    var _this$props3 = this.props,
      resetKeys = _this$props3.resetKeys,
      onResetKeysChange = _this$props3.onResetKeysChange;
    if (error !== null && !this.updatedWithError) {
      this.updatedWithError = true;
      return;
    }
    if (error !== null && changeArray(prevProps.resetKeys, resetKeys)) {
      onResetKeysChange === null || onResetKeysChange === void 0 ? void 0 : onResetKeysChange(prevProps.resetKeys, resetKeys);
      this.reset();
    }
  };
  _proto.reset = function reset() {
    this.updatedWithError = false;
    this.setState(initialState);
  };
  _proto.render = function render() {
    var _this$props4 = this.props,
      fallback = _this$props4.fallback,
      FallbackComponent = _this$props4.FallbackComponent,
      fallbackRender = _this$props4.fallbackRender;
    var error = this.state.error;

    // 多种 fallback 的判断
    if (error !== null) {
      var fallbackProps = {
        error: error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if ( /*#__PURE__*/React.isValidElement(fallback)) {
        return fallback;
      }
      if (typeof fallbackRender === 'function') {
        return fallbackRender(fallbackProps);
      }
      if (FallbackComponent) {
        return /*#__PURE__*/React.createElement(FallbackComponent, fallbackProps);
      }

      // return <div>{t('TOGGLR_FAILURE', '数据异常，请刷新重试')}</div>
      return /*#__PURE__*/React.createElement("div", null, "\u6570\u636E\u5F02\u5E38\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5");
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.children);
  };
  return ErrorBoundary;
}(React.Component); // HOC 高阶函数
function withErrorBoundary(Component, errorBoundaryProps) {
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React.createElement(Component, props));
  };

  // DevTools 显示的组件名，方便调试
  var name = Component.displayName || Component.name || 'Unknown';
  Wrapped.displayName = "withErrorBoundary(" + name + ")";
  return Wrapped;
}

// 提供 ErrorBoundary 无法捕获的错误，在 React 声明周期抛出，以便 ErrorBoundary 捕获
function useErrorHandler(givenError) {
  var _React$useState = React.useState(null),
    error = _React$useState[0],
    setError = _React$useState[1];
  if (givenError) throw givenError;
  if (error) throw error;
  return setError;
}
export { withErrorBoundary, useErrorHandler };
export default ErrorBoundary;